<app-parallax></app-parallax>
<app-nav></app-nav>
<app-image-text></app-image-text>
<app-fullscreen-image></app-fullscreen-image>
<app-contact-form></app-contact-form>
